import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Electrotechnique from "./pages/Electrotechnique";
import IRVE from "./pages/IRVE";
import Location from "./pages/Location";
import DAO from "./pages/DAO";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AdminLogin, { RequireAdmin } from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import AdminRealisations from "./pages/AdminRealisations";
import Users from "./pages/Users";
import Unsubscribe from "./pages/Unsubscribe";
import MentionsLegales from "./pages/MentionsLegales";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/electrotechnique" element={<Electrotechnique />} />
            <Route path="/irve" element={<IRVE />} />
            <Route path="/location" element={<Location />} />
            <Route path="/dao" element={<DAO />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireAdmin><Admin /></RequireAdmin>} />
          <Route path="/admin/realisations" element={<RequireAdmin><AdminRealisations /></RequireAdmin>} />
          <Route path="/admin/users" element={<RequireAdmin><Users /></RequireAdmin>} />
          <Route path="/desinscription" element={<Unsubscribe />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
